export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fc1a9f5475fac6474919771046749a3e97141a573&name=fetchTypeahead!'